import React from 'react';

const Write = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57699 2.32422H6.46116C3.89866 2.32422 2.29199 4.13839 2.29199 6.70672V13.6351C2.29199 16.2034 3.89116 18.0176 6.46116 18.0176H13.8145C16.3853 18.0176 17.9845 16.2034 17.9845 13.6351V10.2784"
        stroke="#1A1E27"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35652 9.10074L13.584 2.87324C14.3599 2.09824 15.6174 2.09824 16.3932 2.87324L17.4074 3.88741C18.1832 4.66324 18.1832 5.92158 17.4074 6.69658L11.1499 12.9541C10.8107 13.2932 10.3507 13.4841 9.87069 13.4841H6.74902L6.82736 10.3341C6.83902 9.87074 7.02819 9.42908 7.35652 9.10074Z"
        stroke="#1A1E27"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6377 3.83545L16.4427 7.64045"
        stroke="#1A1E27"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Write;
